import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { SETTINGS_INJECTION_TOKENS } from '@tourfold/shared-kernels/settings-registry';
import { ResourceAccessGuard } from '@tourfold/shared-kernels/resource-access';
import { AiAssistantSettingsComponent } from './ai-assistant-settings.component';

export function provideSettingsElementAiAssistant(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: SETTINGS_INJECTION_TOKENS,
      useValue: {
        path: 'ai-assistant',
        name: 'AI Assistant',
        icon: 'pi pi-sparkles',
        component: AiAssistantSettingsComponent,
        order: 1,
        translateName: 'AI_ASSISTANT.SETTINGS.TITLE',
        resource_key: 'aiAssistantSettings',
        required_action: 'read',
        planLockedBehavior: 'upsell',
        entitlementFeatureKey: 'ai-assistant',
        canActivate: [ResourceAccessGuard],
        category: {
          id: 'other',
          name: 'Other',
          order: 3,
          translateName: 'SETTINGS.CATEGORIES.OTHER',
        },
      },
      multi: true,
    },
  ]);
}
